import { NavItem } from './nav-item/nav-item';

export const navItems: NavItem[] = [

  // ═══════════════════════════════════════════════════════════
  //  ADMIN / SUPER-ADMIN  SIDEBAR
  // ═══════════════════════════════════════════════════════════

  // ── Dashboard ─────────────────────────────────────────────
  {
    navCap: 'Home',
    roles: ['SuperAdmin', 'Admin'],
  },
  {
    displayName: 'Dashboard',
    iconName: 'layout-dashboard',
    route: '/dashboards/admin',
    roles: ['SuperAdmin', 'Admin'],
  },

  // ── User Management ───────────────────────────────────────
  {
    navCap: 'User Management',
    roles: ['SuperAdmin', 'Admin'],
  },
  {
    displayName: 'Admins',
    iconName: 'user-cog',
    route: '/pages/admins',
    roles: ['Admin'],
  },
  {
    displayName: 'Farm Managers',
    iconName: 'tractor',
    route: '/pages/farm-managers',
    roles: ['SuperAdmin', 'Admin'],
  },
  {
    displayName: 'Farmers',
    iconName: 'wheat',
    route: '/pages/farmers',
    roles: ['SuperAdmin', 'Admin'],
  },
  {
    displayName: 'Consultants',
    iconName: 'user-star',
    route: '/pages/consultants',
    roles: ['SuperAdmin', 'Admin'],
  },
  {
    displayName: 'Testers',
    iconName: 'bug',
    route: '/pages/testers',
    roles: ['SuperAdmin', 'Admin'],
  },

  // ── Vendor Management ─────────────────────────────────────
  {
    navCap: 'Vendor Management',
    roles: ['SuperAdmin', 'Admin'],
  },
  {
    displayName: 'Vendors',
    iconName: 'building-store',
    route: '/pages/vendors',
    roles: ['SuperAdmin', 'Admin'],
  },
  {
    displayName: 'Product Categories',
    iconName: 'category',
    route: '/pages/vendor-category',
    roles: ['SuperAdmin', 'Admin'],
  },
  {
    displayName: 'Product Attributes',
    iconName: 'adjustments-alt',
    route: '/pages/approvals/attribute-templates',
    roles: ['SuperAdmin', 'Admin'],
  },

  // ── Farm Resources ────────────────────────────────────────
  {
    navCap: 'Farm Resources',
    roles: ['SuperAdmin', 'Admin'],
  },
  {
    displayName: 'Farms',
    iconName: 'plant',
    route: '/pages/farms',
    roles: ['SuperAdmin', 'Admin'],
  },
  {
    displayName: 'Land Registry',
    iconName: 'map-2',
    route: '/pages/lands',
    roles: ['SuperAdmin', 'Admin'],
  },
  {
    displayName: 'Villages',
    iconName: 'building-community',
    route: '/pages/villages',
    roles: ['SuperAdmin', 'Admin'],
  },
  {
    displayName: 'Contracts',
    iconName: 'file-text',
    route: '/pages/contracts',
    roles: ['SuperAdmin', 'Admin'],
  },

  // ── Approvals & Finance ───────────────────────────────────
  {
    navCap: 'Operations',
    roles: ['SuperAdmin', 'Admin'],
  },
  {
    displayName: 'Approvals',
    iconName: 'checks',
    route: '/pages/approvals',
    roles: ['SuperAdmin', 'Admin'],
  },
  {
    displayName: 'Tester Payments',
    iconName: 'cash',
    route: '/pages/tester-payments',
    roles: ['SuperAdmin', 'Admin'],
  },
  {
    displayName: 'Seed Trials',
    iconName: 'plant-2',
    route: '/pages/seed-trials',
    roles: ['SuperAdmin', 'Admin'],
  },
  {
    displayName: 'Procedures',
    iconName: 'clipboard-list',
    route: '/pages/procedures',
    roles: ['SuperAdmin', 'Admin'],
  },
  {
    displayName: 'Farm Operations',
    iconName: 'report-analytics',
    route: '/pages/farm-ops-reports',
    roles: ['SuperAdmin', 'Admin'],
  },

  // ═══════════════════════════════════════════════════════════
  //  VENDOR  SIDEBAR
  // ═══════════════════════════════════════════════════════════

  {
    navCap: 'Home',
    roles: ['Vendor'],
  },
  {
    displayName: 'Dashboard',
    iconName: 'layout-dashboard',
    route: '/dashboards/vendor',
    roles: ['Vendor'],
  },
  {
    navCap: 'Store',
    roles: ['Vendor'],
  },
  {
    displayName: 'My Products',
    iconName: 'package',
    route: '/pages/vendor-portal',
    roles: ['Vendor'],
  },
  {
    displayName: 'Contracts',
    iconName: 'file-text',
    route: '/pages/vendor-portal/contracts',
    roles: ['Vendor'],
  },
  {
    navCap: 'Account',
    roles: ['Vendor'],
  },
  {
    displayName: 'Profile',
    iconName: 'user',
    route: '/pages/vendor-portal/profile',
    roles: ['Vendor'],
  },

  // ═══════════════════════════════════════════════════════════
  //  CONSULTANT  SIDEBAR
  // ═══════════════════════════════════════════════════════════

  {
    navCap: 'Home',
    roles: ['Consultant'],
  },
  {
    displayName: 'Dashboard',
    iconName: 'layout-dashboard',
    route: '/dashboards/consultant',
    roles: ['Consultant'],
  },
  {
    navCap: 'Services',
    roles: ['Consultant'],
  },
  {
    displayName: 'Requests',
    iconName: 'clipboard-list',
    route: '/pages/consultant-portal/requests',
    roles: ['Consultant'],
  },
  {
    displayName: 'Service Types',
    iconName: 'list-details',
    route: '/pages/consultant-portal/service-types',
    roles: ['Consultant'],
  },
  {
    displayName: 'My Contract',
    iconName: 'file-text',
    route: '/pages/consultant-portal/contract',
    roles: ['Consultant'],
  },
  {
    displayName: 'My Reviews',
    iconName: 'star',
    route: '/pages/consultant-portal/reviews',
    roles: ['Consultant'],
  },
  {
    navCap: 'Account',
    roles: ['Consultant'],
  },
  {
    displayName: 'Profile',
    iconName: 'user',
    route: '/pages/consultant-portal/profile',
    roles: ['Consultant'],
  },

  // ═══════════════════════════════════════════════════════════
  //  FARM MANAGER / PRINCIPAL FARM MANAGER  SIDEBAR
  // ═══════════════════════════════════════════════════════════

  {
    navCap: 'Home',
    roles: ['FarmManager', 'PrincipalFarmManager'],
  },
  {
    displayName: 'Dashboard',
    iconName: 'layout-dashboard',
    route: '/dashboards/farm-manager-dashboard',
    roles: ['FarmManager', 'PrincipalFarmManager'],
  },

  {
    navCap: 'Daily Operations',
    roles: ['FarmManager', 'PrincipalFarmManager'],
  },
  {
    displayName: 'Check In/Out',
    iconName: 'clock-check',
    route: '/pages/fm-portal/check-in',
    roles: ['FarmManager', 'PrincipalFarmManager'],
  },
  {
    displayName: 'Daily Reports',
    iconName: 'notebook',
    route: '/pages/fm-portal/daily-reports',
    roles: ['FarmManager', 'PrincipalFarmManager'],
  },
  {
    displayName: 'My Tasks',
    iconName: 'checklist',
    route: '/pages/fm-portal/tasks',
    roles: ['FarmManager', 'PrincipalFarmManager'],
  },
  {
    displayName: 'Input Requests',
    iconName: 'shopping-cart',
    route: '/pages/fm-portal/input-requests',
    roles: ['FarmManager', 'PrincipalFarmManager'],
  },
  {
    displayName: 'Deliveries',
    iconName: 'truck-delivery',
    route: '/pages/fm-portal/deliveries',
    roles: ['FarmManager', 'PrincipalFarmManager'],
  },

  {
    navCap: 'Management',
    roles: ['PrincipalFarmManager'],
  },
  {
    displayName: 'Approve Requests',
    iconName: 'clipboard-check',
    route: '/pages/fm-portal/approve-requests',
    roles: ['PrincipalFarmManager'],
  },
  {
    displayName: 'Verify Deliveries',
    iconName: 'package-check',
    route: '/pages/fm-portal/verify-deliveries',
    roles: ['PrincipalFarmManager'],
  },
  {
    displayName: 'Standup Report',
    iconName: 'report',
    route: '/pages/fm-portal/standup',
    roles: ['PrincipalFarmManager'],
  },
  {
    displayName: 'FM Performance',
    iconName: 'chart-bar',
    route: '/pages/fm-portal/fm-performance',
    roles: ['PrincipalFarmManager'],
  },

  // ═══════════════════════════════════════════════════════════
  //  FARMER (OWNER)  SIDEBAR
  // ═══════════════════════════════════════════════════════════

  {
    navCap: 'Home',
    roles: ['Farmer'],
  },
  {
    displayName: 'Dashboard',
    iconName: 'layout-dashboard',
    route: '/dashboards/farmer',
    roles: ['Farmer'],
  },
  {
    navCap: 'Farm Operations',
    roles: ['Farmer'],
  },
  {
    displayName: 'Input Approvals',
    iconName: 'clipboard-check',
    route: '/pages/farmer-portal/approvals',
    roles: ['Farmer'],
  },

  // ═══════════════════════════════════════════════════════════
  //  TESTER  SIDEBAR
  // ═══════════════════════════════════════════════════════════

  {
    navCap: 'Home',
    roles: ['Tester'],
  },
  {
    displayName: 'Dashboard',
    iconName: 'layout-dashboard',
    route: '/dashboards/tester',
    roles: ['Tester'],
  },
  {
    navCap: 'Work',
    roles: ['Tester'],
  },
  {
    displayName: 'My Lands',
    iconName: 'map-2',
    route: '/pages/tester-portal',
    roles: ['Tester'],
  },
  {
    displayName: 'Earnings',
    iconName: 'currency-naira',
    route: '/pages/tester-portal/earnings',
    roles: ['Tester'],
  },
];
